<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.standing.global.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.standing.global.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th [i18nKey]="'parameters.standing.global.weight'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.global.target.weight'"></td>
            <td>
                <input type="number" step="1" [(ngModel)]="parameters.targetWeight"
                       [disabled]="areParametersReadonly()"/>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.global.axes.weight'"></td>
            <td>
                <input type="number" step="1" [(ngModel)]="parameters.communicationAxesWeight"
                       [disabled]="areParametersReadonly()"/>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.global.menu.weight'"></td>
            <td>
                <input type="number" step="1" [(ngModel)]="parameters.menuWeight"
                       [disabled]="areParametersReadonly()"/>
            </td>
        </tr>
        </tbody>
    </table>
</div>
